import { Plus } from '@zoomit/icons';
import { cn, cssVar, Flex, Link, Popover } from '@zoomit/primitives';
import type { MenuItemType } from '@zoomit/web-kit';
import { theme } from '@zoomit/zoomit-ds';

import { useResponsiveMenu } from '../../../hooks/menus/useResponsiveMenu';

type Props = {
  items: MenuItemType[];
  isTransparent?: boolean;
  onHover?: () => void;
  customMoreButton?: React.ReactNode;
  popOverMinAxis?: number;
};

export const DefaultMenuMoreItems = (props: Props) => {
  const { items, isTransparent, onHover, customMoreButton, popOverMinAxis = 12 } = props;

  const { moreItemColumns } = useResponsiveMenu({ items });

  return (
    <Popover
      className={'xxl:hidden'}
      triggerOffset={{
        mainAxis: popOverMinAxis,
      }}
      placement={'bottom-end'}
      content={
        <div
          className={
            'bg-card xxl:hidden shadow-main z-10 hidden min-w-36 origin-right flex-col gap-3 rounded-md p-6 lg:flex'
          }
        >
          {moreItemColumns.map((item, i) => (
            <div className={cn('flex flex-col gap-2')} key={`more-item-col-${i}`}>
              {item?.children?.length ? (
                <Popover
                  enableHideRules={false}
                  isHoverable
                  placement="left"
                  content={
                    <div
                      className={'bg-card shadow-main z-10 flex flex-col gap-3 rounded-md p-6'}
                      key={`more-item-col-${i}`}
                    >
                      {item?.children?.map((item) => (
                        <Link
                          key={`more-link-col-${i}`}
                          rel={item.noFollow ? 'nofollow' : undefined}
                          className={cn(
                            'text-h6 hover:text-primary2 text-text inline-block leading-8 font-normal',
                          )}
                          href={item.url || '#'}
                        >
                          {item.title}
                        </Link>
                      ))}
                    </div>
                  }
                >
                  <Link
                    key={`more-link-col-${i}`}
                    rel={item.noFollow ? 'nofollow' : undefined}
                    className={cn(
                      'text-h6 hover:text-primary2 text-text inline-block leading-8 font-normal text-nowrap',
                    )}
                    href={item.url || '#'}
                  >
                    {item.title}
                  </Link>
                </Popover>
              ) : (
                <Link
                  key={`more-link-col-${i}`}
                  rel={item.noFollow ? 'nofollow' : undefined}
                  className={cn(
                    'text-h6 hover:text-primary2 text-text inline-block leading-8 font-normal text-nowrap',
                  )}
                  href={item.url || '#'}
                >
                  {item.title}
                </Link>
              )}
            </div>
          ))}
        </div>
      }
    >
      {customMoreButton ? (
        customMoreButton
      ) : (
        <Flex className={'relative'}>
          <Flex
            onPointerEnter={onHover}
            style={{ color: isTransparent ? cssVar(theme.white) : cssVar(theme.text) }}
            className={cn('text-h6 group cursor-pointer leading-8 font-black')}
            alignItems={'center'}
            gap={0.6}
          >
            <Plus size={'md'} />
            بیشتر
          </Flex>
        </Flex>
      )}
    </Popover>
  );
};
